import React from 'react';
import { Link } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import RetinaImage from 'react-retina-image';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { Component } from 'ml-component-web';

import logo from '../assets/logo_100.png';
import logo2x from '../assets/logo_100@2x.png';
import './header.css';

export default class Header extends Component {
    render() {
        return (
            <Navbar className="main-navbar" collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/">
                            <RetinaImage className="logo" src={[logo, logo2x]} alt="MyBabyBio" />
                            MyBabyBio
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight>
                        <LinkContainer to="/">
                            <NavItem eventKey={1}>Home</NavItem>
                        </LinkContainer>
                        <LinkContainer to="/about">
                            <NavItem eventKey={2}>About</NavItem>
                        </LinkContainer>
                        <LinkContainer to="/faq">
                            <NavItem eventKey={2}>FAQs</NavItem>
                        </LinkContainer>
                        <li role="presentation"><a href="https://blog.mybabybio.com">Blog</a></li>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/component/Header.js
 **/